import axios from 'axios';

import { saveWarehouse } from 'services/ErplyAPI/warehouses';
import { getMSEndpointFromLS } from 'reducers/installer';

import {
  CancelRequest,
  ConnectionStatusResponse,
  CreateLaneRequest,
  Lane,
  PaymentRequest,
  PaymentResponse,
  RefundRequest,
  ReversalRequest,
  VoidRequest,
} from './types';

const defaultTriPosEndpoint = 'https://localhost.erply.com:9000/';

const getTriPosUrl = () =>
  getMSEndpointFromLS('triPOS') || defaultTriPosEndpoint;

// TODO: Refactor triPOS requests

// export const testConnection = () => {
//   return triposRequest
//     .get('/api/v1/testConnection')
//     .then(
//       response => {
//         return response.statusText;
//       },
//       err => {
//         throw err;
//       },
//     )
//     .catch(e => {
//       throw e;
//     });
// };

export function requestSale(params: Omit<PaymentRequest, 'transactionType'>) {
  return axios.post<PaymentResponse>(`${getTriPosUrl()}api/v1/payment`, {
    transactionType: '1',
    ...params,
  });
}
export function requestVoid(params: Omit<VoidRequest, 'transactionType'>) {
  return axios.post<PaymentResponse>(`${getTriPosUrl()}api/v1/void`, {
    transactionType: '1',
    ...params,
  });
}

/**
 * @deprecated Was intended to be used for referenced refund, but it was found that a referenced refund can be voided, so for safety continue using
 */
export function requestCancel(params: Omit<CancelRequest, 'transactionType'>) {
  return axios.post<PaymentResponse>(`${getTriPosUrl()}api/v1/cancel`, {
    transactionType: '1',
    ...params,
  });
}

export function requestReversal(
  params: Omit<ReversalRequest, 'transactionType'>,
) {
  return axios.post<PaymentResponse>(`${getTriPosUrl()}api/v1/reversal`, {
    transactionType: '1',
    ...params,
  });
}

export function requestReturn(params: Omit<RefundRequest, 'transactionType'>) {
  return axios.post<PaymentResponse>(`${getTriPosUrl()}api/v1/refund`, {
    transactionType: '1',
    ...params,
  });
}

export function requestGetLanes(params) {
  return axios.get<Lane[]>(`${getTriPosUrl()}cloudapi/v1/lanes`, {
    ...params,
  });
}

export function requestPostLane(params: CreateLaneRequest) {
  return axios.post(`${getTriPosUrl()}cloudapi/v1/lanes`, params);
}

export function requestCloudConnection(params: {}, laneId: number) {
  return axios.get<ConnectionStatusResponse>(
    `${getTriPosUrl()}cloudapi/v1/lanes/${laneId}/connectionstatus`,
    {
      ...params,
    },
  );
}

export async function saveTriposConfig({ config, warehouseID, posID }) {
  try {
    await saveWarehouse({
      warehouseID,
      attributeName0: `tripos-posid-${posID}`,
      attributeType0: 'text',
      attributeValue0: JSON.stringify(config),
    });
  } catch (err) {
    console.error('Failed to save TriPOS configuration', err);
  }
}
